import { DelistWarning } from "module/market/component/MarketDetail"

import { Container, Grid, GridItem, VStack } from "@chakra-ui/react"
import { TitleText } from "component/Title/TitleText"
import { TitleBarStats } from "component/TitleBarStats"
import useDimensions from "react-cool-dimensions"

import { NewsFeed } from "../NewsFeed"
import { AccountCard } from "./AccountCard"
import { CollateralCard } from "./CollateralCard"
import { RiskCard } from "./RiskCard"

const PageHome = () => {
    // container aware style for account card
    const { observe } = useDimensions({
        breakpoints: { sm: 0, md: 608, lg: 800 },
    })

    return (
        <Container maxW="1020px" pt={[0, 0, 8]} pb={40}>
            <TitleText title="Hello" subtitle="Here's your summary" />
            {/* TODO: refactor DelistWarning */}
            <DelistWarning />
            <VStack align={"stretch"} pt={{ base: 4, lg: 6 }} pb={6} gap={6} w={"100%"}>
                <Grid
                    w="full"
                    templateRows={{ base: "auto", lg: "auto" }}
                    templateColumns={{ base: "auto", lg: "1fr 1fr 1fr" }}
                    gap={6}
                    columnGap={{ base: 0, lg: 6 }}
                >
                    <GridItem colSpan={{ base: 1, lg: 2 }} ref={observe}>
                        <AccountCard />
                    </GridItem>
                    <GridItem>
                        <RiskCard />
                    </GridItem>
                </Grid>
                <CollateralCard />
                <NewsFeed />
            </VStack>
            <TitleBarStats />
        </Container>
    )
}

export default PageHome
